import { render, staticRenderFns } from "./MonatComponent.vue?vue&type=template&id=631d59ee&"
import script from "./MonatComponent.vue?vue&type=script&lang=js&"
export * from "./MonatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports